import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

// Services
import {
  getQuestion,
  IGetQuestionResponse,
  deleteQuestion
} from 'services/question';

// Types

// Components
import { FancyAvatar } from '../../components/Avatar';
import Box from '../../components/Box';
import Button from '../../components/Button';
import Dialog from '../../components/Dialog';
import Grid from '../../components/Grid';
import Paper from '../../components/Paper';
import { CircularProgress } from '../../components/Progress';
import Tabs, { Tab } from '../../components/Tabs';
import Typography from '../../components/Typography';

import QuestionDialogResponse from './QuestionDialogResponse';
import QuestionDialogRecipients from './QuestionDialogRecipients';

// Style
import './QuestionDialog.css';

// Component
interface IProps {
  state: { open: boolean; questionId: string | null; networkId: string | null };
  onClose?: () => void;
  onDeleted: () => void;
  userRole: 'USER' | 'ADMIN';
}

class UserDialog extends React.Component<IProps, {}> {
  @observable tabIndex = 0;
  @observable.ref question: IGetQuestionResponse | null = null;

  handleDialogEnter = () => {
    this.getQuestion();
  };

  handleDialogExited = () => {
    this.question = null;
  };

  async getQuestion() {
    this.question = await getQuestion({
      params: { networkId: this.props.state.networkId! },
      query: { questionId: this.props.state.questionId! }
    });
  }

  handleQuestionDelete = async () => {
    await deleteQuestion({
      params: { networkId: this.props.state.networkId! },
      query: { questionId: this.props.state.questionId! }
    });
    this.props.onDeleted();
  };

  handleTabChange = (e: React.ChangeEvent<{}>, index: number) => {
    this.tabIndex = index;
  };

  render() {
    return (
      <Dialog
        open={this.props.state.open}
        onEnter={this.handleDialogEnter}
        onExited={this.handleDialogExited}
        onClose={this.props.onClose}
        classes={{ paper: 'AppNetworkQuestion__QuestionDialog__Paper' }}
      >
        {this.question === null ? (
          <Grid
            container={true}
            direction="column"
            alignItems="center"
            justify="center"
            spacing={0}
            style={{ height: 700 }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <div>
            <Paper
              className={'AppNetworkQuestion__QuestionDialog__header'}
              square={true}
            >
              <Box pa={5}>
                <div
                  className={'AppNetworkQuestion__QuestionDialog__header__row'}
                >
                  <div
                    className={
                      'AppNetworkQuestion__QuestionDialog__header__avatar'
                    }
                  >
                    <FancyAvatar
                      text={`${this.question.authorFirstName} ${
                        this.question.authorLastName
                      }`}
                      src={this.question.authorPhotoUrl}
                      size={128}
                    />
                  </div>
                  <div
                    className={
                      'AppNetworkQuestion__QuestionDialog__header__content'
                    }
                  >
                    <Typography type="headline" color="inherit">
                      {this.question.description}
                    </Typography>
                    <Typography
                      type="body1"
                      color="inherit"
                      style={{ opacity: 0.6 }}
                    >
                      By{' '}
                      {`${this.question.authorFirstName} ${
                        this.question.authorLastName
                      }`}
                    </Typography>
                  </div>
                </div>
              </Box>
              <Tabs
                value={this.tabIndex}
                onChange={this.handleTabChange}
                centered={true}
              >
                <Tab label="Response" />
                <Tab label="Recipients" />
              </Tabs>
            </Paper>
            <div
              style={{ height: 400, overflowY: 'auto', background: '#f4f5fa' }}
            >
              {this.tabIndex === 0 ? (
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <QuestionDialogResponse
                    style={{ flexGrow: 1 }}
                    question={this.question}
                  />
                  {this.props.userRole === 'ADMIN' ? (
                    <Box pa={3}>
                      <Button
                        style={{ width: '100%' }}
                        color="secondary"
                        raised={true}
                        onClick={this.handleQuestionDelete}
                      >
                        Delete
                      </Button>
                    </Box>
                  ) : null}
                </div>
              ) : null}
              {this.tabIndex === 1 ? (
                <QuestionDialogRecipients
                  networkId={this.props.state.networkId!}
                  questionId={this.question.questionId!}
                />
              ) : null}
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}

export default observer(UserDialog);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkQuestions/QuestionDialog.tsx